import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiParameterHelperService } from './parameter-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiParameterService {
  constructor(
    public helper: ApiParameterHelperService,
    private _api: ApiService,
  ) {}

  get(id: string) {
    return this._api.get('parameter/get/id/' + id);
  }

  values(ids: string[]) {
    return this._api.post('parameter/values', { ids });
  }

  list(data: any = {}) {
    return this._api.post('parameter/list', data);
  }

  updateBulk(data: any = {}) {
    return this._api.post('parameter/update-bulk', data);
  }
}
